import React from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "../../../../components/ui/form";
import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";
import { Cross2Icon } from "@radix-ui/react-icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectSeparator,
} from "../../../../components/ui/select";

interface LocationSelectProps {
  field: any;
  FormField: any;
}

export function LocationSelect({ field }: LocationSelectProps) {
  const [isAddingNew, setIsAddingNew] = React.useState(false);
  const [newLocation, setNewLocation] = React.useState("");

  const handleNewLocation = () => {
    if (newLocation.trim()) {
      field.onChange(newLocation.trim());
      setIsAddingNew(false);
      setNewLocation("");
    }
  };

  if (isAddingNew) {
    return (
      <FormItem className="space-y-1">
        <FormLabel>New Location</FormLabel>
        <div className="flex gap-2">
          <FormControl>
            <Input
              value={newLocation}
              onChange={(e) => setNewLocation(e.target.value)}
              placeholder="Enter location name"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleNewLocation();
                } else if (e.key === 'Escape') {
                  setIsAddingNew(false);
                  setNewLocation("");
                }
              }}
            />
          </FormControl>
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={() => {
              setIsAddingNew(false);
              setNewLocation("");
            }}
          >
            <Cross2Icon className="h-4 w-4" />
          </Button>
        </div>
        <p className="text-xs text-muted-foreground">
          Press Enter to save or X to cancel
        </p>
        <FormMessage />
      </FormItem>
    );
  }

  return (
    <FormItem>
      <FormLabel>Location</FormLabel>
      <Select
        onValueChange={(value) => {
          if (value === "new") {
            setIsAddingNew(true);
          } else {
            field.onChange(value);
          }
        }}
        value={field.value}
      >
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder="Select location" />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          <SelectItem value="main-storage">Main Storage</SelectItem>
          <SelectItem value="pharmacy">Pharmacy</SelectItem>
          <SelectItem value="clinic">Clinic</SelectItem>
          <SelectSeparator />
          <SelectItem value="new" className="text-primary">
            + Create new location
          </SelectItem>
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  );
}
